import { FunctionComponent } from 'react';
import { Avatar, Checkbox, Flex, Text } from '@chakra-ui/react';

type TeamSearchRowProps = {
  uuid: string;
  name: string;
  acronym?: string;
  logoPath?: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onToggle: () => void;
};

/** Linha de um time na lista de busca (esquerda do Step 3 Times). */
export const TeamSearchRow: FunctionComponent<TeamSearchRowProps> = ({
  name,
  acronym,
  logoPath,
  isSelected,
  isDisabled,
  onToggle,
}) => (
  <Flex
    as="label"
    align="center"
    gap={3}
    px={3}
    py={2}
    borderRadius="md"
    cursor={isDisabled ? 'not-allowed' : 'pointer'}
    bg={isSelected ? 'purple.50' : 'transparent'}
    _hover={{ bg: isDisabled ? undefined : 'gray.50' }}
    opacity={isDisabled ? 0.5 : 1}
  >
    <Avatar size="sm" name={acronym || name} src={logoPath} />
    <Flex direction="column" flex="1" minW={0}>
      <Text fontWeight="medium" isTruncated>
        {name}
      </Text>
      {acronym ? (
        <Text fontSize="12px" color="gray.500">
          {acronym}
        </Text>
      ) : null}
    </Flex>
    <Checkbox
      colorScheme="brand"
      isChecked={isSelected}
      isDisabled={isDisabled}
      onChange={onToggle}
    />
  </Flex>
);
